/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2024-05-23 15:36:22
 * @Description:
 */
export default {
  name: 'MenuItem',
  props: {
    menuData: {
      type: Object,
      default: () => { }
    },
    fieldsMap: {
      default: () => ({}),
      type: Object
    }
  },
  data: () => ({
    // count: 0
  }),
  mounted() {
  },
  render() {
    const { menuData, fieldsMap: { id, path: pathKey, label: labelKey, icon, children: childrenKey} } = this
    if(!menuData) {
      return ''
    }
    const menuIcon = menuData[icon];
    const children = menuData[childrenKey] || [];
    const path = menuData[pathKey]
    const name = menuData[labelKey]

    const svgIcon = menuIcon && <svg-icon iconClass={menuIcon} isMenuIcon={true} style={{marginRight: '6px'}}/>
    let renderData = (
      <el-menu-item
        key={menuData[id]}
        index={path}
        ref="subMenu"
      >
        {svgIcon}
        <span slot="title">
          { name }
        </span>
      </el-menu-item>
    )

    if (children.length) {
      renderData = (
        <el-submenu
          index={path}
        >
          <template slot="title">
            {svgIcon}
            <span  slot="title">{ name }</span>
          </template>
          {
            children.map((item) => {
              const key = item[id]
              const path = item[pathKey]
              return (
                <MenuItem
                  key={key}
                  index={path}
                  menuData={item}
                  fieldsMap={this.fieldsMap}
                />
              )
            })
          }
        </el-submenu>
      )
    }
    return renderData
  }
}
